export * from "./fipe-arrow-icon.component";
